import axiosInstance from "../../services/axiosInstance";
import * as S from "./style";
import { NavLink } from "react-router-dom";
import { useEffect, useState } from "react";
//Components
import Footer from "../../components/Footer";
import Loading from "../../components/Loading";
import NoData from "../../components/NoData";
import TitleMenu from "../../components/Title/TitleMenu";
import Auth401 from "../../components/Error/Auth";
import Erro429 from "../../components/Error/Erro429";
//Hooks
import useLoading from "../../hooks/useLoading";
import { useMultipleModal } from "../../hooks/useMultipleModal";
import { apiExport } from "../../hooks/apiExport";
//Interface
import { IPage } from "Interfaces/IPage";
import { IStock } from "Interfaces/IStock";

export default function Stock() {
  const [data, setData] = useState<IStock[]>([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [page, setCurrentPage] = useState<IPage>({
    id: 0,
    last_page: 0,
    current_page: 0,
    total: 0,
    per_page: 0
  });
  const { isOpenModal, toggleModalVisibility } = useMultipleModal();
  const { isLoading, startLoading, stopLoading } = useLoading();

  //Header da tabela
  const listHeaderTable = [
    "Nome",
  ];

  //Pop menu do botão New
  const titleListPopMenu = [
    "Lente",
    "Antirreflexo",
    "Tipo de Lente",
    "Sensibilidade",
  ];
  const titlePopButtton = ["lens", "anti-glare", "type-lens", "sensitivity"];

  const handleSearchChange = (term: string) => {
    setSearchTerm(term);
    fetchData();
  };

  const fetchData = async (pageNumber = 1, perPage = 10) => {
    startLoading();
    try {
      let url = `/api-stock-lens?page=${pageNumber}&per_page=${perPage}`;
      if (searchTerm.trim()) {
        url += `&search=${searchTerm}`;
      }
      const response = await axiosInstance.get(url);
      const dataResponse = response.data;

      setData(dataResponse.data);
      setCurrentPage(dataResponse);
    } catch (error: any) {
      if (error.status === 401) {
        toggleModalVisibility('auth');
      } else if (error.status === 429) {
        toggleModalVisibility('request429');
      }
      console.log("Error: ", error);
    } finally {
      stopLoading();
    }
  };

  useEffect(() => {
    const debounceFetch = setTimeout(() => {
      fetchData();
    }, 300);

    return () => clearTimeout(debounceFetch);
  }, [searchTerm]);

  if (isOpenModal("auth")) {
    return (
      <Auth401 isOpen={isOpenModal("auth")} />
    )
  } else if (isOpenModal("request429")) {
    return (
      <Erro429 />
    )
  }

  const exportData = async () => {
    startLoading();
    try {
      await apiExport("/lens-export-pdf"); // Passe a URL diretamente
    } catch (error) {
      alert(`Erro ao exportar dados: ${error}`);
    } finally {
      stopLoading();
    }
  };

  return (
    <S.Container>
      <TitleMenu
        filterSearch={handleSearchChange}
        title="Estoque de Lentes"
        subtitle="Gerencie seu estoque de lentes"
        placeholderSearch="Nome da Lente"
        listPopMenu={titleListPopMenu}
        fetchData={fetchData}
        listPopButton={titlePopButtton}
        exportButton={exportData}
        visibleButton={false}
      />
      {isLoading ? (
        <Loading />
      ) : (
        <S.Content>
          <S.ContaintableButton>
            <S.Table>
              <S.THead>
                <tr>
                  {listHeaderTable.map((header, index) => (
                    <th key={index}>{header}</th>
                  ))}
                </tr>
              </S.THead>

              <S.TBody>
                {data.length > 0 ? (
                  data.map((val, index) => (
                    <tr key={index}>
                      <td>
                        <NavLink
                          to='/estoqueDeLenteLab'
                          state={{ id: val.id }}
                          style={{ color: "black", textDecoration: "none" }}
                          key={index + 1}>
                          <S.ButtonNav>
                            {val.name_lens || "-"}
                          </S.ButtonNav>
                        </NavLink>
                      </td>
                    </tr>
                  ))
                ) : (
                  <NoData />
                )}
              </S.TBody>
            </S.Table>
          </S.ContaintableButton>
        </S.Content>
      )}

      {page && (
        <Footer
          fetchData={fetchData}
          currentPage={page.current_page}
          lastPage={page.last_page}
          allPerPage={page.total}
        />
      )}
    </S.Container>
  );
}
